import { ChangeGamePayload } from '../../models';
import { IntegrationBase } from './base';

export class VirtualIntegration extends IntegrationBase {

  public changeGame(params: ChangeGamePayload): void {
    const { data: launchData } = this.rootStore.gameStore.launchData;
    if (!launchData) return;
    const { gameId, mode = launchData.mode, tournamentId, source } = params;
    const { partnerId, culture, gameId: fromGameId } = launchData;
    this.rootStore.gameStore.getGameLaunchInfo({
      gameId,
      mode,
      partnerId,
      culture,
      tournamentId
    }, fromGameId, source);

    // reset necessary states
    this.rootStore.lobbyStore.setIsLobbyOpen(false);
    this.rootStore.lobbyStore.resetPreLobbyGamesResponse();
    this.rootStore.tournamentStore.setTournamentFrameOpen(false);
  }
}
